import React, { useState } from 'react';
import { Brain, MessagesSquare, Network, Calendar, MessageCircle } from 'lucide-react';
import { ProductDescriptionModal } from './ProductDescriptionModal';
interface HeroProps {
  onJoinBeta: () => void;
}
export const Hero = ({
  onJoinBeta
}: HeroProps) => {
  const [showProductModal, setShowProductModal] = useState(false);
  const handleWhatsApp = () => {
    window.open('https://wa.me/40736718154', '_blank');
  };
  const handleCalendar = () => {
    window.open('https://calendar.app.google/WBT3DtVNB8v87CEYA', '_blank');
  };
  return <>
      <div className="bg-gradient-to-b from-[#d5ff00]/10 to-white pt-32 pb-24" data-id="element-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-801">
          <div className="text-center" data-id="element-802">
            <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-803">
              AI-Powered Outreach
              <br data-id="element-804" />
              <span className="text-[#6366f1]" data-id="element-805">
                Human-Guided by Expert SDRs
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-806">
              Stop wasting time on generic automation. Get personalized B2B
              outreach campaigns managed by Irina, a sales expert with 17+ years
              of experience, powered by AI that actually converts.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-24" data-id="element-807">
              <button onClick={handleWhatsApp} className="px-8 py-4 bg-[#25D366] text-white rounded-xl text-lg font-semibold hover:bg-[#20BA5A] shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2" data-id="element-808">
                <MessageCircle size={24} data-id="element-809" />
                Chat on WhatsApp
              </button>
              <button onClick={handleCalendar} className="px-8 py-4 bg-[#6366f1] text-white rounded-xl text-lg font-semibold hover:bg-[#5457e5] shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2" data-id="element-810">
                <Calendar size={24} data-id="element-811" />
                Book a Meeting
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-812">
              <FeatureCard icon={<Brain size={28} strokeWidth={2} data-id="element-814" />} title="Expert-Guided Strategy" description="Irina personally designs your targeting strategy and oversees every campaign" data-id="element-813" />
              <FeatureCard icon={<MessagesSquare size={28} strokeWidth={2} data-id="element-816" />} title="AI-Powered Personalization" description="Advanced AI crafts messages that resonate, with human oversight for quality" data-id="element-815" />
              <FeatureCard icon={<Network size={28} strokeWidth={2} data-id="element-818" />} title="Weekly Support & Reporting" description="Regular check-ins, full advisory, and transparent reporting on every lead" data-id="element-817" />
            </div>
          </div>
        </div>
      </div>
      <ProductDescriptionModal isOpen={showProductModal} onClose={() => setShowProductModal(false)} onComplete={() => {
      setShowProductModal(false);
      handleWhatsApp();
    }} data-id="element-819" />
    </>;
};
const FeatureCard = ({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => <div className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-lg border border-gray-100 transition-all duration-300 hover:shadow-xl" data-id="element-820">
    <div className="w-16 h-16 bg-[#d5ff00]/20 rounded-2xl flex items-center justify-center mb-6 text-[#6366f1]" data-id="element-821">
      {icon}
    </div>
    <h3 className="text-lg font-semibold mb-3 text-gray-900" data-id="element-822">{title}</h3>
    <p className="text-gray-600 text-center leading-relaxed" data-id="element-823">{description}</p>
  </div>;